// This function is used to rename data when it's used for the "AboutThis" component for Campaigns; it would be imported into the component where Campaigns component is also imported:
export const getCampaignsData = ({
    campaigns,
    campaignPath,
    campaignPathReplace,
    type
}) => {
    // if no campaigns, early return:
    if (!campaigns) {
        return;
    }

    // map over items & create new data object;
    const newDataObject = campaigns.map(campaign => {
        const currentDate = Date.now();

        if (type === "photos") {
            const {
                id,
                title,
                slugWithId,
                hideFromUsersInUx,
                isDisabled,
                publishStartTime,
                publishEndTime
            } = campaign;

            // build "showLink" flag for each:
            const pubStartTime = new Date(publishStartTime).getTime();

            const pubEndTime = new Date(publishEndTime).getTime();

            const activateLink = currentDate > pubStartTime;

            const deactivateLink =
                pubEndTime > 0 ? currentDate > pubEndTime : false;

            // make src link for image:
            const campaignLink = campaignPath.replace(
                campaignPathReplace,
                slugWithId
            );

            // return new data shape:
            return {
                id,
                title,
                slugWithId,
                hideFromUsersInUx,
                isDisabled,
                publishStartTime,
                publishEndTime,
                url: campaignLink,
                showLink:
                    !hideFromUsersInUx &&
                    !isDisabled &&
                    activateLink &&
                    !deactivateLink
            };
        } else if (type === "icons") {
            // todo - update this when we know the shape of icons campaigns:

            const {
                id,
                title,
                slugWithId,
                hideFromUsersInUx,
                isDisabled,
                publishStartTime,
                publishEndTime
            } = campaign;

            // build "showLink" flag for each:
            const pubStartTime = new Date(publishStartTime).getTime();

            const pubEndTime = new Date(publishEndTime).getTime();

            const activateLink = currentDate > pubStartTime;

            const deactivateLink =
                pubEndTime > 0 ? currentDate > pubEndTime : false;

            // make src link for image:
            const campaignLink = campaignPath.replace(
                campaignPathReplace,
                slugWithId
            );

            // return new data shape:
            return {
                id,
                title,
                slugWithId,
                hideFromUsersInUx,
                isDisabled,
                publishStartTime,
                publishEndTime,
                url: campaignLink,
                showLink:
                    !hideFromUsersInUx &&
                    !isDisabled &&
                    activateLink &&
                    !deactivateLink
            };
        } else {
            // we shouldnt actually get to this condition; this is just here just in case:
            return {
                id: "",
                slug: "",
                name: "",
                hideFromUsersInUx: true,
                isDisabled: true,
                publishStartTime: null,
                publishEndTime: null,
                url: "",
                showLink: false
            };
        }
    });

    return newDataObject;
};
